<ng-container *ngIf="orderTotals$ | async as orderTotals">
  <ng-container *ngIf="orderTotals.total > 0; else freeLabel">
    <div class="pricing-row">
      <span>{{ 'FRONTEND.STORE.SUBTOTAL' | translate }}</span>
      <span class="pricing">
        <billing-ui-simple-price-display
          [price]="(orderTotals.subtotal || 0) * 100"
          [currencyCode]="orderTotals.currency"
          [frequency]="Frequency.ONE_TIME"
        ></billing-ui-simple-price-display>
      </span>
    </div>
    <ng-container *ngFor="let tax of orderTotals.taxes">
      <div class="pricing-row">
        <span>
          {{ 'FRONTEND.STORE.TAX' | translate : { percentage: tax.percentage } }}
        </span>
        <span class="pricing">
          <billing-ui-simple-price-display
            [price]="(tax.tax || 0) * 100"
            [currencyCode]="orderTotals.currency"
            [frequency]="Frequency.ONE_TIME"
          ></billing-ui-simple-price-display>
        </span>
      </div>
    </ng-container>
    <div class="pricing-row">
      <span>
        <strong>{{ 'FRONTEND.STORE.TOTAL' | translate }}</strong>
      </span>
      <span class="pricing">
        <strong>
          <billing-ui-simple-price-display
            [price]="(orderTotals.total || 0) * 100"
            [currencyCode]="orderTotals.currency"
            [frequency]="Frequency.ONE_TIME"
          ></billing-ui-simple-price-display>
        </strong>
      </span>
    </div>
  </ng-container>
  <ng-template #freeLabel>
    <div class="pricing-row">
      <span class="pricing">
        {{ 'FRONTEND.STORE.FREE' | translate }}
      </span>
    </div>
  </ng-template>
</ng-container>
